module.exports = import("https://www.gstatic.com/firebasejs/11.1.0/firebase-app.js");;